import { render, staticRenderFns } from "./GrcDocDisplayer.vue?vue&type=template&id=422daf89&scoped=true&"
import script from "./GrcDocDisplayer.vue?vue&type=script&lang=js&"
export * from "./GrcDocDisplayer.vue?vue&type=script&lang=js&"
import style0 from "./GrcDocDisplayer.vue?vue&type=style&index=0&id=422daf89&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422daf89",
  null
  
)

export default component.exports